@if (!isDialogOpen() && isJournalRequestLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
} @else {
<div mat-dialog-title class="title">
    <span class="heading">Journal Request</span>
    @if (isDialogOpen()) {
    <div class="title-actions">
        <button type="button" mat-icon-button (click)="openInNewTab()" class="new-tab">
            <mat-icon>open_in_new</mat-icon>
        </button>
        <button type="button" mat-dialog-close mat-icon-button (click)="closeDialog()">
            <mat-icon class="close-icon-color">cancel</mat-icon>
        </button>
    </div>
    }
</div>
<div #dialogContent mat-dialog-content>
    <form [formGroup]="journalRequestForm">
        <div class="header-content">
            @if (showReturnReason) {
            <mat-form-field subscriptSizing="dynamic" class="fullLength">
                <mat-label style="color: red;">Rejected Reason</mat-label>
                <input matInput formControlName="returnReason" readonly>
            </mat-form-field>
            }

            @if (isRejectionRequested) {
            <div class="rejection-request">
                <mat-icon formControlName="rejectionWarning">warning</mat-icon>
                <span>Action required: Partner has requested this payment be reversed and rejected.</span>
            </div>
            }

            <div>
                <mat-form-field class="fullWidth" subscriptSizing="dynamic">
                    <mat-label>Matter From</mat-label>
                    <input readonly matInput formControlName="matterFromName" />
                </mat-form-field>

                @if (showLinkToOpenMatter1()) {
                <div class="sticky-actionstep-bar">
                    <div class="link-wrapper">
                        <a [href]="actionstepMatterUrl1" target="_blank" rel="noopener noreferrer">
                            Open Matter in Actionstep ({{ matterFromNo }})
                        </a>
                        <button type="button" mat-icon-button class="small-copy-btn"
                                [cdkCopyToClipboard]="actionstepMatterUrl1"
                                (cdkCopyToClipboardCopied)="onUrlCopied()"
                                matTooltip="Copy link to clipboard"
                                matTooltipPosition="below">
                            <mat-icon>content_copy</mat-icon>
                        </button>
                    </div>
                    <div class="warning-box">
                        You must be logged into Actionstep under the same jurisdiction.
                    </div>
                </div>
                }
            </div>

            <div>
                <mat-form-field class="fullWidth" subscriptSizing="dynamic">
                    <mat-label>Matter To</mat-label>
                    <input readonly matInput formControlName="matterToName" />
                </mat-form-field>

                @if (showLinkToOpenMatter2()) {
                <div class="sticky-actionstep-bar">
                    <div class="link-wrapper">
                        <a [href]="actionstepMatterUrl2" target="_blank" rel="noopener noreferrer">
                            Open Matter in Actionstep ({{ matterToNo }})
                        </a>
                        <button type="button" mat-icon-button class="small-copy-btn"
                                [cdkCopyToClipboard]="actionstepMatterUrl2"
                                (cdkCopyToClipboardCopied)="onUrlCopied()"
                                matTooltip="Copy link to clipboard"
                                matTooltipPosition="below">
                            <mat-icon>content_copy</mat-icon>
                        </button>
                    </div>
                    <div class="warning-box">
                        You must be logged into Actionstep under the same jurisdiction.
                    </div>
                </div>
                }
            </div>
        </div>

        <mat-tab-group class="request-tab" color="accent" [animationDuration]="'0ms'" [disableRipple]="true" dynamicHeight="true">
            <mat-tab label="Request Details">
                <div [ngClass]="{
                        'tab-content-wrapper-return': isDialogOpen() && showReturnReason,
                        'tab-content-wrapper': isDialogOpen() && !showReturnReason,
                        'extended-tab-content-return-wrapper': !isDialogOpen() && showReturnReason,
                        'extended-tab-content-wrapper': !isDialogOpen() && !showReturnReason
                     }">
                    <div class="form-content">
                        <div class="search">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Client Bank</mat-label>
                                <mat-select formControlName="clientBankAccount1" required>
                                    @for (account of filteredBankAccounts; track account.accountId) {
                                    <mat-option [value]="account">
                                        {{ account.accountId }} - {{ account.description }}
                                    </mat-option>
                                    }
                                </mat-select>
                                <mat-error *ngIf="journalRequestForm.get('clientBankAccount1')?.hasError('required')">
                                    Please select a bank account.
                                </mat-error>
                            </mat-form-field>

                            @if (showLinkToOpenMatter1()) {
                            <div class="actionstep-matter-overview">
                                <div class="link-wrapper">
                                    <a [href]="actionstepMatterOverviewUrl1" target="_blank" rel="noopener noreferrer">
                                        Open Actionstep Matter ({{ matterFromNo }}) Overview
                                    </a>
                                    <button type="button" mat-icon-button class="small-copy-btn"
                                            [cdkCopyToClipboard]="actionstepMatterOverviewUrl1"
                                            (cdkCopyToClipboardCopied)="onUrlCopied()"
                                            matTooltip="Copy link to clipboard"
                                            matTooltipPosition="below">
                                        <mat-icon>content_copy</mat-icon>
                                    </button>
                                </div>
                                <div class="warning-box">
                                    You must be logged into Actionstep under the same jurisdiction.
                                </div>
                            </div>
                            }
                        </div>

                        <div class="search">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Client Bank</mat-label>
                                <mat-select formControlName="clientBankAccount2" required>
                                    @for (account of filteredBankAccounts; track account.accountId) {
                                    <mat-option [value]="account">
                                        {{ account.accountId }} - {{ account.description }}
                                    </mat-option>
                                    }
                                </mat-select>
                                <mat-error *ngIf="journalRequestForm.get('clientBankAccount2')?.hasError('required')">
                                    Please select a bank account.
                                </mat-error>
                            </mat-form-field>

                            @if (showLinkToOpenMatter2()) {
                            <div class="actionstep-matter-overview">
                                <div class="link-wrapper">
                                    <a [href]="actionstepMatterOverviewUrl2" target="_blank" rel="noopener noreferrer">
                                        Open Actionstep Matter ({{ matterToNo }}) Overview
                                    </a>
                                    <button type="button" mat-icon-button class="small-copy-btn"
                                            [cdkCopyToClipboard]="actionstepMatterOverviewUrl2"
                                            (cdkCopyToClipboardCopied)="onUrlCopied()"
                                            matTooltip="Copy link to clipboard"
                                            matTooltipPosition="below">
                                        <mat-icon>content_copy</mat-icon>
                                    </button>
                                </div>
                                <div class="warning-box">
                                    You must be logged into Actionstep under the same jurisdiction.
                                </div>
                            </div>
                            }
                        </div>

                        <mat-form-field>
                            <mat-label>Reason for Transfer</mat-label>
                            <input matInput formControlName="reason" />
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Amount</mat-label>
                            <input matInput formControlName="amount" appCurrencyInput/>
                        </mat-form-field>

                        <mat-form-field appearance="fill" class="upload-doc">
                            <mat-label>Files to upload</mat-label>
                            <input matInput [value]="displayFile.join(', ')" placeholder="Please select a file" readonly>
                            <button type="button" (click)="fileInput.click()" mat-icon-button matSuffix>
                                <mat-icon>upload_file</mat-icon>
                            </button>
                            @if (displayFile.length > 0) {
                            <button type="button" (click)="clearUpload(fileInput)" mat-icon-button matSuffix>
                                <mat-icon>clear</mat-icon>
                            </button>
                            }
                            <input type="file" id="fileInput" (change)="onFilesSelected($event.target)" #fileInput multiple hidden>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Partner authorising</mat-label>
                            <input readonly matInput formControlName="partnerAuthorising" />
                        </mat-form-field>

                        @if (isDateTransactionVisible) {
                        <div class="date-time-row">
                            <mat-form-field color="accent" class="date-field">
                                <mat-label>Transaction Date</mat-label>
                                <input matInput
                                       [matDatepicker]="dateTransactionPicker"
                                       formControlName="dateTransaction"
                                       placeholder="dd/MM/yyyy"
                                        [max]="currentDate"/>
                                <mat-datepicker-toggle matSuffix [for]="dateTransactionPicker" />
                                <mat-datepicker #dateTransactionPicker />
                                @if (journalRequestForm.get('dateTransaction')?.touched &&
                                journalRequestForm.get('dateTransaction')?.invalid) {
                                <mat-error>Please select a date.</mat-error>
                                }
                            </mat-form-field>

                            <mat-form-field color="accent" class="time-field">
                                <mat-label>Transaction Time</mat-label>
                                <input matInput
                                       type="time"
                                       formControlName="transactionTime" />
                            </mat-form-field>
                        </div>
                        }

                        <div class="date-time-row">
                            <mat-form-field color="accent" class="date-field">
                                <mat-label>Requested Date</mat-label>
                                <input matInput
                                       [matDatepicker]="dateRequestedPicker"
                                       formControlName="dateRequested"
                                       placeholder="dd/MM/yyyy" />
                                <mat-datepicker-toggle matSuffix [for]="dateRequestedPicker" />
                                <mat-datepicker #dateRequestedPicker />
                            </mat-form-field>

                            <mat-form-field color="accent" class="time-field">
                                <mat-label>Requested Time</mat-label>
                                <input matInput
                                       type="time"
                                       formControlName="requestedTime" />
                            </mat-form-field>
                        </div>

                        @if (journalRequestForm.get('dateAuthorized')?.value) {
                        <mat-form-field color="accent">
                            <mat-label>Date authorised</mat-label>
                            <input matInput
                                   [matDatepicker]="pickerDateAuth"
                                   placeholder="Date authorised"
                                   formControlName="dateAuthorized"
                                   readonly />
                            <mat-datepicker-toggle matSuffix color="mat-accent"
                                                   [for]="pickerDateAuth"></mat-datepicker-toggle>
                            <mat-datepicker #pickerDateAuth></mat-datepicker>
                        </mat-form-field>
                        }

                        @if (journalRequestForm.get('dateAuthorized')?.value) {
                        <mat-form-field color="accent">
                            <mat-label>Date authorised</mat-label>
                            <input matInput
                                   [matDatepicker]="dateAuthPicker"
                                   placeholder="Date authorised"
                                   formControlName="dateAuthorized"
                                   readonly />
                            <mat-datepicker-toggle matSuffix color="mat-accent" [for]="dateAuthPicker"></mat-datepicker-toggle>
                            <mat-datepicker #dateAuthPicker></mat-datepicker>
                        </mat-form-field>
                        }

                        @if (journalData.comments?.length) {
                        @for (item of journalData.comments; let i = $index; track i) {
                        <mat-form-field>
                            <mat-label>{{ i + 1 }}. {{ StagesLabel[item.stageId ?? item.currentStageId!] }}</mat-label>
                            <textarea matInput [value]="item.comment" readonly></textarea>
                        </mat-form-field>
                        }
                        }

                        @if (!disableButtons) {
                        <mat-form-field class="fullLength">
                            <mat-label>Add Comments/Notes</mat-label>
                            <textarea matInput formControlName="comments"></textarea>
                        </mat-form-field>
                        }

                        @if (showFundsCheckedByPartner) {
                        <mat-checkbox class="fullLength" formControlName="fundsCheckedByPartner">
                            I confirm that available funds have been checked.<span class="important">*</span>
                        </mat-checkbox>
                        }

                        @if (FundsCheckedPartnerText) {
                        <mat-checkbox class="fullLength" formControlName="fundsCheckedByPartner">
                            Available funds have been checked by partner.
                        </mat-checkbox>
                        }

                        @if (isAmountReleased) {
                        <mat-checkbox class="fullLength" formControlName="isCheckedLedger">I have confirmed that I have checked the ledger for available funds.<span class="important">*</span></mat-checkbox>
                        }
                    </div>
                </div>
            </mat-tab>

            <mat-tab label="Attachments" [disabled]="!hasAttachments">
                <div [ngClass]="{
                        'tab-content-wrapper-return': isDialogOpen() && showReturnReason,
                        'tab-content-wrapper': isDialogOpen() && !showReturnReason,
                        'extended-tab-content-return-wrapper': !isDialogOpen() && showReturnReason,
                        'extended-tab-content-wrapper': !isDialogOpen() && !showReturnReason
                     }">
                    <xp-attachment-list *ngIf="hasAttachments" [attachments]="journalData.documents" />
                </div>
            </mat-tab>

            <mat-tab label="Audit">
                <xp-audit-log [ngClass]="{
                        'dialog-mode-rejected': isDialogOpen() && showReturnReason,
                        'dialog-mode': isDialogOpen() && !showReturnReason,
                        'extended-mode-rejected-journal': !isDialogOpen() && showReturnReason,
                        'extended-mode-journal': !isDialogOpen() && !showReturnReason
                     }"
                              [requestId]="getRequestId" [requestType]="RequestType.Journal" [showPaginator]="false" />
            </mat-tab>
        </mat-tab-group>
    </form>
</div>
<div mat-dialog-actions class="action-buttons">
    <div class="left-buttons">
        <button type="button" [disabled]="!hasAttachments" (click)="downloadDocuments(journalData.id, 'Journal')"
                mat-raised-button color="accent" matTooltip="Download documents">
            Download Attachments
        </button>
    </div>
    <div class="right-buttons">
        <button type="button" [disabled]="disableButtons || journalRequestForm.invalid" (click)="approveRequest()"
                mat-raised-button color="accent">
            {{ approveBtn }}
        </button>

        @if (previousStages.length === 0) {
        <button type="button" [disabled]="disableButtons" (click)="delete()" mat-raised-button color="warn">
            Reject
        </button>
        } @else {
        <button type="button" [disabled]="disableButtons" mat-raised-button [matMenuTriggerFor]="rejectMenu" color="warn">
            Reject
            <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>

        <mat-menu #rejectMenu="matMenu">
            @for (previousStage of previousStages; track previousStage.stageOrder) {
            <span [matTooltip]="isReturnDisabled(previousStage.stageOrder) ? 'This request must be returned to the Accounts team for reversal.' : ''"
                  matTooltipPosition="right"
                  matTooltipShowDelay="300">
                <button mat-menu-item
                        [disabled]="isReturnDisabled(previousStage.stageOrder)"
                        (click)="returnRequest(previousStage.stageOrder, previousStage.rejectStatus || 'Return')">
                    {{ previousStage.rejectStatus }}
                </button>
            </span>
            }
            <mat-divider></mat-divider>
            <span [matTooltip]="isStagePartner2Return ? 'This request must be returned to the Accounts team for reversal.' : ''"
                  matTooltipPosition="right"
                  matTooltipShowDelay="300">
                <button mat-menu-item [disabled]="isStagePartner2Return" (click)="delete()">
                    Reject
                </button>
            </span>
        </mat-menu>
        }
    </div>
</div>
}
